import context from 'static/script/app/ui/checkout2/context/context';
import { getMessagingPageLink } from 'tradera-apps/my-tradera/app/helpers/messaging-helpers';
riot.tag2('checkout-shipping', '<div class="co-panel"> <h2>{t(\'checkout_shipping_title\')}</h2> <div class="co-content"> <div class="co-shipping-content-left"> {model.streetName} <br> {model.zipCode}&nbsp;{model.town} <br> {model.country} <br> </div> <div class="co-shipping-content-right"> <div class="co-radio-new {co-radio-selected:IsSelected} {co-striked:striked}" onclick="{selectShippingMethod}" each="{model.shippingOptions}"> <div class="header"> <div class="cell"> <div class="checkmark" if="{!isNotSpecifiedItem(shippingType)}"></div> <div class="checkmark visibilityHidden" if="{isNotSpecifiedItem(shippingType)}"></div> </div> <div class="cell co-shipping-options-flag" if="{toCountryCode}"> <img riot-src="{getFlagUrl(toCountryCode)}" alt="International shipping flag"> </div> <div class="cell"> <div if="{showShippingIcon(shippingType)}" class="{getShippingIconClass(shippingType)}"></div> <span if="{!showShippingIcon(shippingType)}">{displayText}</span> </div> <div class="cell-right" if="{!isNotSpecifiedItem(shippingType)}"> {t(\'checkout_shipping_cost\', {shippingCost: shippingCost})} </div> <div class="cell-right" if="{isNotSpecifiedItem(shippingType)}"> <a href="{getMessagingLink()}" class="link"> {t(\'checkout_shipping_cost_quote\')} </a> </div> </div> </div> <div if="{model.showInternationalWarning}" class="field-validation-error"> Notera att beräknad fraktkostnad endast gäller inom Sverige. Kontakta säljaren! </div> </div> <div style="clear: both"></div> </div> </div> <div class="co-panel-divider"></div>', '', '', function(opts) {
        this.model = opts.model;

        this.on('mount', function() {
            //alert('shipping mounted: ' + opts.data);
        });

        var selectedItem = null;
        this.selectShippingMethod = function (event) {
            if(event.target && event.target.href) {
                // This is a workaround since the link click otherwise gets swallowed by this clickhandler and the link won't work.
                window.location.href = event.target.href;
                return;
            }
            if (event.item.striked) {
                return;
            }
            if (selectedItem) {
                selectedItem.IsSelected = false;
            }
            selectedItem = event.item;

            event.item.IsSelected = true;
            context.observable.trigger('shipping-changed', event.item);
            if(this.isNotSpecifiedItem(event.item.shippingType)) {
                context.observable.trigger('payment-not-valid', event.item);
                context.observable.trigger('shipping-type-selected', null);
            } else {
                context.observable.trigger('shipping-type-selected', event.item.shippingType);
                context.observable.trigger('payment-valid', event.item);
            }
        };

        this.setInitialSelection = () => {
            const notStriked = this.model.shippingOptions.find(so => !so.striked);
            this.selectShippingMethod({
                item: notStriked
            });
        }

        this.getShippingIconClass = function(shippingType) {
            return 'icon-' + shippingType.toLowerCase();
        }

        this.getFlagUrl = function(toCountryCode) {
            return toCountryCode ? `/static/images/flags/${toCountryCode}.svg` : '';
        }

        this.showShippingIcon = function(shippingType) {
            switch (shippingType.toLowerCase()) {
                case 'posten':
                case 'dhl':
                case 'schenkerprivpak':
                case 'bussgods':
                    return true;

                default:
                    return false;
                }
        }

        this.isNotSpecifiedItem = function(shippingType) {
            return shippingType.toLowerCase() === 'notspecified';
        }

        this.getMessagingLink = function() {
            const url = getMessagingPageLink(
                this.model.sellerId,
                this.model.buyerId,
                this.model.itemId,
                {
                    traderaUserId: this.model.buyerId,
                    singleThread: false,
                    openForm: true,
                    source: 'contact_seller'
                }
            );
            return this.toLocalizedUrl(url);
        };

        this.setInitialSelection();

});
